import { render, staticRenderFns } from "./SuppliersSlider.vue?vue&type=template&id=33de928c&scoped=true&"
import script from "./SuppliersSlider.vue?vue&type=script&lang=js&"
export * from "./SuppliersSlider.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersSlider.vue?vue&type=style&index=0&id=33de928c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de928c",
  null
  
)

export default component.exports